import { ethers as o } from "ethers";
import { SniperContractAbi as e } from "@deorderbook/contracts/abi";
import { signer as c, provider as i } from "./provider.mjs";
const s = /* @__PURE__ */ new Map(), p = (t) => {
  const n = new o.Contract(
    t,
    e
  );
  return s.set(t, n), n;
}, f = (t, n = !1) => {
  const r = p(t);
  return n ? r.connect(c) : r.connect(i);
};
export {
  p as initSniperContract,
  s as sniperContracts,
  f as useSniperContract
};
//# sourceMappingURL=sniperContract.mjs.map
